import { proxy } from 'valtio'
import { CommonApi, Option } from '../../generated'
import { apiConfig } from '../apiConfig'
import { isJa } from '../i18n/useLang'
import { getName } from '../util/getName'

export const applicationCategoriesStore = proxy<{ items: Option[] }>({
  items: [],
})

const api = new CommonApi(apiConfig)
export async function loadApplicationCategories() {
  await api.getApplicationCategories().then((result) => {
    applicationCategoriesStore.items = result
  })
}

export function getApplicationCategoryName(id?: number, defaultValue?: string, isOther?: boolean) {
  if (id === undefined) return '' // todo 見直す
  return getName(applicationCategoriesStore.items, id, defaultValue, isOther)
}

export function getApplicationCategoryOptions(applicationCategories: {
  items: Option[]
}): Array<Option & { label: string; value: string }> {
  const key = isJa() ? 'nameJa' : 'name'
  const result = applicationCategories.items.map((c) => ({
    ...c,
    value: c.code,
    label: c[key],
  }))
  result.sort((a, b) => {
    if (a.isOther) return 1
    if (b.isOther) return -1
    if (a.label < b.label) {
      return -1
    } else if (a.label === b.label) {
      return 0
    } else {
      return 1
    }
  })
  return result
}
